import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Clients } from './components/Clients';
import { Process } from './components/Process';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
const META_TITLE = 'ICL Collective — Digital Marketing Agency | Paid Media, Social & Analytics';
const META_DESCRIPTION = 'ICL Collective is a digital marketing services company offering paid media management, social media management, landing pages and analytics reporting for businesses across the Americas.';
export function App() {
  useEffect(() => {
    document.title = META_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
  }, []);
  return <div className="min-h-full w-full bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="3ii4su47vuwpm">
      <Navbar data-id="element-1" data-mp="3mjq2lgp4euvl" />
      <main data-id="element-2" data-mp="3mj6ibtbzzuee">
        <Hero data-id="element-3" data-mp="3rc9dg5wfbbwp" />
        <Services data-id="element-4" data-mp="3rbra6pbcfxfa" />
        <Clients data-id="element-5" data-mp="3rdaq2et386gj" />
        <Process data-id="element-6" data-mp="3rcsyvwla8ifh" />
        <About data-id="element-7" data-mp="3recedkz46pg7" />
        <Contact data-id="element-8" data-mp="5yjsutqtdfe" />
      </main>
      <Footer data-id="element-9" data-mp="67yvnd9206b" />
    </div>;
}